import type { ApiClient } from './client.js';
import type { ClassroomLayoutDto, UpdateClassroomLayoutBody } from './types.js';

/**
 * Classroom layout client: the server-backed sections + standalone pages that
 * make up the customizable live experience (replaces the per-device
 * localStorage page list). Read returns the effective layout (stored, else the
 * registry default); put replaces it.
 */
export interface LayoutApi {
  get(classroomId: string): Promise<ClassroomLayoutDto>;
  put(classroomId: string, body: UpdateClassroomLayoutBody): Promise<ClassroomLayoutDto>;
}

export function createLayoutApi(client: ApiClient): LayoutApi {
  return {
    async get(classroomId) {
      const res = await client.get<{ layout: ClassroomLayoutDto }>(
        `/api/classrooms/${classroomId}/layout`,
      );
      return res.layout;
    },
    async put(classroomId, body) {
      const res = await client.put<{ layout: ClassroomLayoutDto }>(
        `/api/classrooms/${classroomId}/layout`,
        body,
      );
      return res.layout;
    },
  };
}
